export default __webpack_public_path__ + "static/media/git.43d387b7.svg";